import './loader.css'

const CommentLoader = () => {

    return (
        <div className="btn-loader"></div>
    )
}

export default CommentLoader;